import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import ScanDestinationForSort from './ScanDestinationForSort';
import { setPageToRender, SortContainerPages } from 'src/store/common-slices/sortContainerSlice';

const mapStateToProps = (state: RootState) => ({
    selectedSortType: state.SortContainer.selectedSortType
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    setPageToRender: (pageToRender: SortContainerPages) => dispatch(setPageToRender(pageToRender)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScanDestinationForSort);
